module.exports = __webpack_public_path__ + "img/3.f8c758a.jpg";